import {
  BackendJourneyConversionEvent,
  Campaign,
  RawAttributionMode,
  RawConversion,
} from 'modules/workflows/types';
import { ATTRIBUTION_MODE_LOOKUP } from '../../BaseSendEditor.constants';
import { StyledValues, StyledValuesContainer } from './MultipleConversionSelection.styles';

export const getMultiselectValues = (conversions: Campaign['conversions'] = []) => {
  return conversions.reduce(
    (acc: string[], conversion: RawConversion) => [...acc, ...conversion.events.map((e) => e.name)],
    [],
  );
};

export const getModeFromCustomConversion = (customConversion: Campaign['customConversion']) =>
  customConversion?.attributionMode;

export const getPeriodFromCustomConversion = (customConversion: Campaign['customConversion']) =>
  customConversion?.attributionPeriodHours;

export const getModeFromConversions = (conversions: Campaign['conversions'] = []) =>
  conversions?.[0]?.events?.[0]?.attributionMode;

export const getModeNameFromConversions = (conversions: Campaign['conversions'] = []) =>
  ATTRIBUTION_MODE_LOOKUP[getModeFromConversions(conversions)?.name];

export const getPeriodFromConversions = (conversions: Campaign['conversions'] = []) =>
  getModeFromConversions(conversions)?.periodHours;

export const updateAttributionModeConfig = (
  conversions: RawConversion[] = [],
  newModeConfig: Partial<RawAttributionMode> = {},
) =>
  conversions.map((conversion) => ({
    ...conversion,
    events: (conversion.events || []).map((event) => ({
      ...event,
      attributionMode: {
        ...event.attributionMode,
        ...newModeConfig,
      },
    })),
  }));

export const getSelectedValueNamesAsTooltip = (values: string[]) => {
  return (
    <StyledValuesContainer>
      {values.map((v, i) => (
        <StyledValues key={v + i}>
          {`${i + 1}) `}
          {v}
        </StyledValues>
      ))}
    </StyledValuesContainer>
  );
};

export const getJourneyGoalAttributionPeriodHours = (
  journeyGoalConversion?: BackendJourneyConversionEvent,
) => journeyGoalConversion?.attributionPeriodHours;
